import { FC } from "react";
import { formInterface } from "@/interface/dataInterface";
import { BaseInput, BaseTextArea } from "@/components/input/CustomInputs";
import { Label } from "@/components/ui/label";
import MultiSelect from "@/components/input/MultiSelect";
import { useGetList } from "react-admin";

const BranchForm: FC<formInterface> = ({
  formProp,
  setFormProp,
  otherData,
  setOtherData,
}) => {
  return (
    <div className="grid grid-cols-2 place-items-center gap-4">
      <BaseInput
        id="name"
        label="Name"
        value={formProp.name}
        setProp={setFormProp}
      />
      <BaseInput
        id="address"
        label="Address"
        value={formProp.address}
        setProp={setFormProp}
      />
      <BaseInput
        id="phone"
        label="Phone number"
        value={formProp.phone}
        setProp={setFormProp}
      />
      <BaseInput
        id="email"
        label="Email"
        type="email"
        placeholder="name@email.com"
        value={formProp.email}
        setProp={setFormProp}
      />
      <BaseInput
        id="opening_hours"
        label="Opening hours"
        placeholder="7:00-20:00"
        value={formProp.opening_hours}
        setProp={setFormProp}
        required={false}
      />
      <div className="w-full">
        <Label htmlFor="users" className="mb-2">
          Users
        </Label>
        <MultiSelect
          resource="users"
          dataProp="firstname"
          selected={otherData || []}
          setSelected={setOtherData || function () {}}
        />
      </div>
      <div className="w-full col-span-2">
        <BaseTextArea
          id="description"
          label="Description"
          value={formProp.description}
          setProp={setFormProp}
          required={false}
        />
      </div>
    </div>
  );
};

export default BranchForm;
